import { FCX } from '@models';
import { SelectCustomSingle } from '@components/Select';
import { useFiltersContext } from '@core/FiltersContext';
import { useBenchmarkNorm } from "@vms/SelectNorm/useBenchmarkNormType";
import { useMemo } from "react";
import cn from "classnames";
import { usePlatformFeatureFlag } from "@datassential/platform-ui-lib";
import { CUSTOM_BENCHMARK_SET_FEATURE } from "@core/constants";

const SelectNorm: FCX<{
    showBenchmarkOption?: boolean;
}> = ({
    showBenchmarkOption: showBenchmarkOptionProp,
}) => {
    const isCustomBenchmarkSetFeatureEnabled = usePlatformFeatureFlag(CUSTOM_BENCHMARK_SET_FEATURE);
    const {
        options: { norms },
        value: { norm },
        updateValue: updateFiltersValue,
    } = useFiltersContext();

    const benchmarkOption = useBenchmarkNorm();

    const isBenchmarkNormActive = useMemo(
        () => norm === benchmarkOption?.id ?? false,
        [norm, benchmarkOption]
    );

    const showBenchmarkOption = useMemo(
        () => isCustomBenchmarkSetFeatureEnabled && showBenchmarkOptionProp,
        [showBenchmarkOptionProp, isCustomBenchmarkSetFeatureEnabled],
    );

    const filteredNorms = useMemo(
        () => showBenchmarkOption ? norms : norms.filter(n => n.id !== benchmarkOption?.id),
        [norms, showBenchmarkOption, benchmarkOption]
    );

    return (
        <SelectCustomSingle
            className={cn(isBenchmarkNormActive && 'is-highlighted')}
            value={norm}
            options={filteredNorms.map((o, index) => ({
                ...o,
                renderTitle: index === 0 ? (
                    <>
                        {o.title}&nbsp;
                        <div style={{ textTransform: 'lowercase' }}>(recommended)</div>
                    </>
                ) : undefined,
            }))}
            label="Benchmark (item vs. __)"
            dpdnClassName="w-auto"
            style={{ minWidth: 150, marginLeft: 16 }}
            onOptionClick={(id) => {
                updateFiltersValue({
                    norm: id,
                })
            }}
        />
    );
};

export default SelectNorm;